import { render, staticRenderFns } from "./SettingsSectionSearch.vue?vue&type=template&id=5f06fea7&scoped=true&"
import script from "./SettingsSectionSearch.vue?vue&type=script&lang=js&"
export * from "./SettingsSectionSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f06fea7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
